/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/jquery.actual.min');
require('./vendor/jquery.validate.min');

// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
require('./vendor/slick.min.js');
require('./app/sliders/slider');
require('./app/sliders/side-slider');
require('./app/sliders/testimonial-slider');
require('./app/sliders/slider-hero');
require('./app/sliders/resources-slider');
require('./app/sliders/partners-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');

// App Requires
require('./app/config');
require('./app/helpers');
require('./app/primaryNav');
require('./app/stickyHeader');
require('./app/modals');
require('./app/horizontal-scroll');
require('./app/transcend-grid');
require('./app/block-text');
require('./app/sameHeight');
require('./app/fourSameHeight');
require('./app/card-team');
require('./app/leadership');
require('./app/to-top');
require('./app/iplocation');
// require('./app/primary-navigation');


